import type { User } from '@/core/domain';
import type { UserRepository } from '../repositories/user-repository';

export interface GetAllUsersOptions {
  forceRefresh?: boolean;
}

export class GetAllUsersUseCase {
  constructor(private readonly repository: UserRepository) {}

  execute(options?: GetAllUsersOptions): Promise<User[]> {
    return this.repository.getAll(options?.forceRefresh === true);
  }
}
